import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { initOperatorTracking } from "./utils/operatorTracking";
import MainPage from "./pages/MainPage";
import LandingPage from "./pages/LandingPage";
import ZSLandingPage from "./pages/ZSLandingPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import PrintPage from "./pages/PrintPage";
import PrintZSPage from "./pages/PrintZSPage";
import SignaturePage from "./pages/SignaturePage";
import AdminRegistrationsPage from "./pages/AdminRegistrationsPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import SupportPage from "./pages/SupportPage";
import OperatorRegistrationPage from "./pages/OperatorRegistrationPage";
import RecordingsPage from "./pages/RecordingsPage";

function App() {
  useEffect(() => { initOperatorTracking(); }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/predskolni-vzdelavani" element={<LandingPage />} />
        <Route path="/zakladni-vzdelavani" element={<ZSLandingPage />} />
        <Route path="/obchodni-podminky" element={<TermsPage />} />
        <Route path="/ochrana-udaju" element={<PrivacyPage />} />
        <Route path="/print" element={<PrintPage />} />
        <Route path="/print-zs" element={<PrintZSPage />} />
        <Route path="/podpis" element={<SignaturePage />} />
        <Route path="/podpora" element={<SupportPage />} />
        <Route path="/zaznamy-ukazek" element={<RecordingsPage />} />
        <Route path="/admin" element={<AdminDashboardPage />} />
        <Route path="/admin/ukazky" element={<AdminDashboardPage />} />
        <Route path="/admin/registrace" element={<AdminRegistrationsPage />} />
        <Route path="/admin/operator-registrace" element={<OperatorRegistrationPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
